import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A WWI canvas field stretcher lying on the ground: two timber carrying poles
// with handles overhanging each end, a canvas bed slung between them, four
// short feet and a folded grey blanket at the head end.
const TIMBER = "#8b6438";
const CANVAS = "#cbbd93";
const BLANKET = "#6f7076";

const POLE_LEN = 0.86; // along Z; handles overhang the canvas at both ends
const POLE_X = 0.19;
const BED_Y = 0.09; // top of the feet, where the poles rest

function foot(x: number, z: number): Part {
  return { geometry: new THREE.BoxGeometry(0.05, 0.07, 0.06), color: TIMBER, position: [x, 0.035, z] };
}

export const stretcher = defineModel({
  id: "stretcher",
  batchId: "wwi",
  author: "Fable 5",
  name: "Stretcher",
  tags: ["wwi", "prop", "medical", "field"],
  summary: "A canvas field stretcher on two timber poles with a folded grey blanket.",
  footprint: 0.45,
  tiles: { w: 1, h: 1 },
  parts(): Part[] {
    return [
      // Four stubby feet
      foot(-POLE_X, -0.32),
      foot(POLE_X, -0.32),
      foot(-POLE_X, 0.32),
      foot(POLE_X, 0.32),
      // Two carrying poles running along Z
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, POLE_LEN, 8), color: TIMBER,
        position: [-POLE_X, BED_Y, 0], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, POLE_LEN, 8), color: TIMBER,
        position: [POLE_X, BED_Y, 0], rotation: [Math.PI / 2, 0, 0] },
      // Canvas bed slung between the poles, shorter than the poles
      { geometry: new THREE.BoxGeometry(POLE_X * 2 + 0.02, 0.025, 0.64), color: CANVAS,
        position: [0, BED_Y, 0] },
      // Folded grey blanket at the head end
      { geometry: new THREE.BoxGeometry(0.3, 0.05, 0.2), color: BLANKET,
        position: [0, BED_Y + 0.037, -0.18] },
    ];
  },
  animations: [],
});
